import React from "react";
import PropTypes from "prop-types";
import OverviewSection from "./OverviewSection";
import { PAGES } from "../../CheckoutProvider";

const AddressSelected = ({ title, address, edit }) => {
    return (
        <OverviewSection title={title} editPage={edit && PAGES.CONTACT_DETAILS}>
            <AddressInformation address={address} />
        </OverviewSection>
    );
};

const AddressInformation = ({ address }) => {
    return (
        <div className="address-overview ph-no-capture">
            <span>{fullName(address?.first_name, address?.last_name)}</span>
            {address?.company && <span>{address.company}</span>}
            <span>{address?.address}</span>
            <span>{postcodeCity(address?.postcode, address?.city)}</span>
        </div>
    );
};

const fullName = (first, last) => {
    return `${first} ${last}`;
};

const postcodeCity = (postcode, city) => {
    return `${postcode} ${city}`;
};

AddressSelected.propTypes = {
    title: PropTypes.string,
    address: PropTypes.object.isRequired,
    edit: PropTypes.bool,
};

AddressInformation.propTypes = {
    address: PropTypes.object.isRequired,
};

export default AddressSelected;
